import { useContext, useLayoutEffect } from 'react';

import { DrawerContext } from './DrawerContext';
import { LayerContext } from './LayerContext';

interface DrawerGuardOptions {
    hasUnsavedChanges?: boolean;
    isBusy?: boolean;
}

export const useDrawerGuard = ({ hasUnsavedChanges, isBusy }: DrawerGuardOptions) => {
    const { id } = useContext(LayerContext);
    const { registerGuard } = useContext(DrawerContext);

    useLayoutEffect(() => {
        if (id === undefined || (hasUnsavedChanges === undefined && isBusy === undefined)) {
            return;
        }
        return registerGuard(id, { hasUnsavedChanges: hasUnsavedChanges ?? false, isBusy: isBusy ?? false });
    }, [hasUnsavedChanges, id, isBusy, registerGuard]);
};
